import moment from "moment-timezone";

// Optional PSA dates stay null; a missing date must not become January 2000.
export function psaDate(value) {
  if (value === null || value === undefined || value === "") return null;
  let date;
  if (typeof value.toDate === "function") {
    date = value.toDate();
  } else if (typeof value.seconds === "number") {
    date = new Date(value.seconds * 1000);
  } else {
    date = new Date(value);
  }
  if (isNaN(date.getTime())) {
    throw new TypeError("Ungültiges PSA-Datum");
  }
  return date;
}

export function formatPsaDate(value, format = "MMM yyyy") {
  const date = psaDate(value);
  return date ? moment(date).format(format) : "-";
}
